"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColour = getColour;
exports.getLineHeight = exports.getFontSize = void 0;
var _palette = _interopRequireDefault(require("@telus-uds/palette-allium/build/web/palette"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getFontSize = size => {
  if (size === 'large') {
    return '1.25rem';
  } else if (size === 'small') {
    return '0.875rem';
  } else if (size === 'micro') {
    return '0.75rem';
  } else {
    return '1rem';
  }
};
exports.getFontSize = getFontSize;
var getLineHeight = size => {
  if (size === 'large') {
    return '32px';
  } else if (size === 'small') {
    return '20px';
  } else if (size === 'micro') {
    return '16px';
  } else {
    return '24px';
  }
};
exports.getLineHeight = getLineHeight;
function getColour(inverse, alternative) {
  if (inverse) {
    return 'white';
  } else if (alternative) {
    return _palette.default.color.greyThunder;
  } else {
    return _palette.default.color.greenAccessible;
  }
}